import axios from "axios";
const RAW = process.env.REACT_APP_BACKEND_URL;
// Assainit l'URL backend : retire un éventuel slash final. Si absente (build mal configuré),
// on retombe sur la même origine pour éviter des URLs invalides "undefined/api".
export const BACKEND_URL = (RAW && RAW !== "undefined" ? RAW : "").replace(/\/+$/, "");
export const API = `${BACKEND_URL}/api`;

// Auth par token JWT (en-tête Authorization) : fiable même en cross-domaine et sur iOS Safari,
// où les cookies tiers (SameSite=None) sont bloqués. On garde withCredentials pour les
// déploiements même-domaine (cookies), mais le token de localStorage est la source principale.
const TOKEN_KEY = "lo_token";
export const getAuthToken = () => localStorage.getItem(TOKEN_KEY);
export const setAuthToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const t = getAuthToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
